import { render, staticRenderFns } from "./memberStatistics.vue?vue&type=template&id=0622adfd&scoped=true&"
import script from "./memberStatistics.vue?vue&type=script&lang=js&"
export * from "./memberStatistics.vue?vue&type=script&lang=js&"
import style0 from "./memberStatistics.vue?vue&type=style&index=0&id=0622adfd&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0622adfd",
  null
  
)

export default component.exports